<template>
  <div class="container">
    <div class="title-box">
      <div class="title">
        <h1>
          行业解决方案
          <br />INDUSTRY SOLUTIONS
        </h1>
        <img src="../assets/img/fangkuai.png" alt />
      </div>
    </div>
    <div class="banner-box">
      <div class="Modul">
        <router-link to="./caseszx">
          <div>
            <img src="../assets/img/07.png" alt />
          </div>
          <p>在线教育</p>
        </router-link>
        <router-link to="./casesds">
          <div>
            <img src="../assets/img/01.png" alt />
          </div>
          <p>电商新零售</p>
        </router-link>
        <router-link to="./caseszf">
          <div>
            <img src="../assets/img/02.png" alt />
          </div>
          <p>政府案例</p>
        </router-link>
        <router-link to="./caseswy">
          <div>
            <img src="../assets/img/03.png" alt />
          </div>
          <p>文化娱乐</p>
        </router-link>
        <router-link to="./casestc">
          <div>
            <img src="../assets/img/04.png" alt />
          </div>
          <p>体彩竞技</p>
        </router-link>
        <router-link to="./casesyl">
          <div>
            <img src="../assets/img/05.png" alt />
          </div>
          <p>医疗健康</p>
        </router-link>
        <router-link to="./caseshl">
          <div>
            <img src="../assets/img/06.png" alt />
          </div>
          <p>互联网金融</p>
        </router-link>
      </div>
    </div>
    <div class="allCase">
      <div class="titlecase">全部案例</div>
      <div class="tag-bar">
        <span
          :class="index == idx ? 'active' : ''"
          v-for="(item, index) in casetype"
          :key="index"
          @click="casetag(item, index)"
          >{{ item.name }}</span
        >
      </div>
      <div class="bg-box">
        <div
          @click="
            toPage({ name: 'details', query: { id: item.id, from: 'csaes' } })
          "
          class="bg-box-small"
          v-for="item in caselists"
          :key="item.id"
        >
          <div class="caseItem">
            <div class="imgBox">
              <img :src="item.pic_url" alt />
            </div>
            <div class="Description">
              <span class="right-btn">→</span>
              <h1>
                <p class="types">{{ item.name }}</p>
                {{ item.title }}
              </h1>
              <p class="dpContent">{{ item.sub_title }}</p>
              <p class="time">{{ item.online_time }}</p>
              <div class="icon-box">
                <div v-for="items in item.icon" :key="items.id">
                  <img :src="items.pic_url" alt />
                  <p class="icon-p">{{ items.title }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style="width:1200px; margin:auto; margin-top:20px; text-align:right">
        <el-pagination
          hide-on-single-page
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          background
          layout="prev, pager, next"
          :total="total"
          :page-size="10"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "../utils/axios";
export default {
  data() {
    return {
      caselists: [],
      casetype: [],
      idx: 0,
      total: 0,
      page: 1,
      currentPage: 1,
      id: ""
    };
  },
  methods: {
    toPage(url) {
      this.$router.push(url);
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    async handleCurrentChange(val) {
      this.page = val;
      var that = this;
      let param = {
        safecode: "slgapicode",
        page: that.page,
        pagenum: 10,
        id: that.id
      };
      await axios
        .fetchPost("/project/projectList", param)
        .then(function(projectList) {
          that.caselists = projectList.data.data.list;
        });
    },
    async getTotal() {
      let param = {
        safecode: "slgapicode"
      };
      var that = this;
      await axios
        .fetchPost("/project/superProjectList", param)
        .then(function(superProjectList) {
          that.casetype = superProjectList.data.data.list;
          that.firstId = that.casetype[0].id;
        });
    },
    async casetag(item, index) {
      var that = this;
      this.id = item.id;
      let param = {
        safecode: "slgapicode",
        // page: that.page,
        pagenum: 10,
        pid: item.id,
        id: item.id
      };
      await axios
        .fetchPost("/project/projectList", param)
        .then(function(projectList) {
          that.caselists = projectList.data.data.list;
          that.total = projectList.data.data.count;
          that.idx = index;
          console.log(item.id);
        });
    },
    // async Paginationbtn(){
    //   let param = {
    //     safecode: "slgapicode",
    //     page: 1,
    //     pagenum: 1,
    //     pid: item.id
    //   };
    //   var that = this;
    //   await axios.fetchPost("/project/projectList", param).then(function(projectList) {
    //     that.caselists = projectList.data.data.list
    //     that.idx = index
    //   });
    // },
    async caselist() {
      let param = {
        safecode: "slgapicode"
      };
      var that = this;
      await axios
        .fetchPost("/project/projectList", param)
        .then(function(projectList) {
          that.caselists = projectList.data.data.list;
          that.total = projectList.data.data.count;
          console.log(that.total);
          console.log(that.caselists);
        });
    }
  },
  mounted() {
    this.getTotal();
    this.caselist();
  }
};
</script>
<style lang="less" scoped>
.container {
  padding-top: 80px;
  background-color: #2445a6;
  .title-box {
    width: 1200px;
    margin: auto;
    padding-top: 40px;
    .title {
      display: flex;
      align-items: center;
      width: 1330px;
      h1 {
        color: white;
        font-size: 36px;
        font-family: SourceHanSansCN-Bold;
        font-weight: bold;
        letter-spacing: 5px;
      }
      img {
        width: 46px;
        height: 41px;
        margin-left: auto;
      }
    }
  }
  .banner-box {
    padding-top: 80px;
    padding-bottom: 80px;
    .Modul {
      display: flex;
      align-items: center;
      justify-content: center;
      a {
        color: white;
        width: 163px;
        box-sizing: border-box;
        margin-right: 10px;
        text-align: center;
        font-weight: bold;
        font-size: 18px;
        cursor: pointer;
        div {
          width: 163px;
          height: 163px;
          overflow: hidden;
        }
        img {
          transition: all 0.6s !important;
          height: 163px;
          overflow: hidden;
        }
        img:hover {
          transform: scale(1.2) !important;
        }
      }
      a:hover {
        color: #ff4e00;
      }
      a:nth-child(7) {
        margin-right: 0px !important;
      }
    }
  }
  .allCase {
    background-color: #243e9f;
    width: 100%;
    padding: 80px 0;
    .titlecase {
      font-size: 32px;
      font-family: SourceHanSansCN-Bold;
      color: white;
      text-align: center;
      margin-bottom: 30px;
    }
    .tag-bar {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 100px;
      span {
        color: #a3bdff;
        font-size: 18px;
        font-family: SourceHanSansCN-Medium;
        padding: 0 20px;
        cursor: pointer;
      }
      .active {
        color: white;
      }
    }
    .bg-box {
      width: 100%;
      .bg-box-small {
        width: 100%;
      }
      .bg-box-small:nth-child(even) {
        background-color: #2445a6;
        .caseItem {
          flex-direction: row-reverse;
        }
      }
    }
    .caseItem {
      width: 1200px;
      margin: auto;
      display: flex;
      justify-content: space-between;
      padding: 90px 0;
      .imgBox {
        width: 300px;
        height: 300px;
        overflow: hidden;
        img {
          width: 300px;
          height: 300px;
          transition: all 0.4s;
        }
        img:hover {
          transform: scale(1.2);
        }
      }
      .Description {
        width: 820px;
        position: relative;
        .right-btn {
          position: absolute;
          right: 0px;
          bottom: 0px;
          width: 40px;
          height: 40px;
          border: 1px solid rgba(77, 125, 245, 1);
          background-color: #243e9f;
          font-size: 24px;
          line-height: 40px;
          text-align: center;
          color: white;
        }
        h1 {
          font-family: SourceHanSansCN-Medium;
          font-size: 26px;
          color: white;
          display: flex;
          align-items: center;
          margin: 0;
          .types {
            width: 120px;
            height: 32px;
            background-image: url("../assets/img/types.png");
            background-repeat: no-repeat;
            background-size: 100% 100%;
            font-size: 12px;
            font-family: SourceHanSansCN-Medium;
            text-align: center;
            line-height: 32px;
            margin-right: 20px !important;
            margin: 0;
          }
        }
      }
      .dpContent {
        color: #a3bdff;
        font-family: SourceHanSansCN-Medium;
        line-height: 30px;
        overflow: hidden;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        text-overflow: ellipsis;
        -webkit-line-clamp: 2; /*限制行数为2行*/
        line-clamp: 2; /*限制行数为2行*/
        text-align: justify !important;
      }
      .time {
        color: #a3bdff;
        font-family: SourceHanSansCN-Medium;
        line-height: 30px;
        margin-bottom: 27px;
      }
      .icon-box {
        display: flex;
        flex-wrap: wrap;
        div {
          box-sizing: border-box;
          background-color: #243e9f;
          position: relative;
          height: 110px;
          width: 110px;
          text-align: center;
          box-sizing: border-box;
          padding: 10px 5px;
          border: #5c79e0 1px solid;
          margin-right: 10px;
          img {
            width: 80px;
            height: 80px;
          }
          .icon-p {
            color: #c8d4ff;
            margin: 0;
            font-size: 12px !important;
            font-weight: normal;
            margin-top: -15px;
            overflow: hidden;
            overflow: hidden;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            text-overflow: ellipsis;
            -webkit-line-clamp: 1; /*限制行数为2行*/
            line-clamp: 1; /*限制行数为2行*/
          }
        }
        div:hover {
          background-color: #2445a6;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/cases.vue